import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PopoverService } from '@app/shared/components/popover/popover.service';
import { UserService } from '@app/shared/services';
import { AjsNgxGuard, AuthGuard, AuthLinkGuard, UnsavedChangesGuard } from './guards';
import {
	AJSService,
	AjsNgxModalService,
	AuthService,
	DialogService,
	FeedbackService,
	FlyoutService,
	HttpCancelService,
	LoadingService,
	NavigationService,
	ReportService,
	RoleService,
	SocketService,
	TitleService,
} from './services';

const guards = [AjsNgxGuard, AuthGuard, AuthLinkGuard, UnsavedChangesGuard];

const services = [
	AJSService,
	AjsNgxModalService,
	AuthService,
	DialogService,
	FeedbackService,
	FlyoutService,
	HttpCancelService,
	LoadingService,
	NavigationService,
	PopoverService,
	ReportService,
	TitleService,
	SocketService,
	RoleService,
];

@NgModule({
	imports: [CommonModule],
	providers: [...guards, ...services, UserService],
	exports: [],
})
export class CoreModule {}
